import httpClient from "./httpClient";
import { getApiBaseUrl } from "../data/authStorage";

const baseUrl = getApiBaseUrl();

export const getOrganizationSetup = async () => (await httpClient.get(`${baseUrl}/organizations/setup`)).data;
export const saveOrganizationSetup = async (payload) => (await httpClient.patch(`${baseUrl}/organizations/setup`, payload)).data;

export const saveOrganizationProfile = async (payload) => (await httpClient.patch(`${baseUrl}/organizations/profile`, payload)).data;
export const createSetupDepartment = async (payload) => (await httpClient.post(`${baseUrl}/organizations/departments`, payload)).data;
export const createSetupLevel = async (payload) => (await httpClient.post(`${baseUrl}/organizations/levels`, payload)).data;
export const createSetupPosition = async (payload) => (await httpClient.post(`${baseUrl}/organizations/positions`, payload)).data;
export const getSetupAttendance = async () => (await httpClient.get(`${baseUrl}/organizations/attendance/settings`)).data;
export const saveSetupAttendance = async (payload) => (await httpClient.patch(`${baseUrl}/organizations/attendance/settings`, payload)).data;
